import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=c3d66490&scoped=true"
import script from "./blocks.vue?vue&type=script&lang=js"
export * from "./blocks.vue?vue&type=script&lang=js"
import style0 from "./blocks.vue?vue&type=style&index=0&id=c3d66490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d66490",
  null
  
)

export default component.exports